import React from "react";
import { Result, Card, Typography, Button } from "antd";
import { CloseCircleOutlined } from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";

const { Text, Title } = Typography;

const PaymentFailed: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Extract session ID from URL (optional)
  const queryParams = new URLSearchParams(location.search);
  const sessionId = queryParams.get("session_id");

  return (
    <Card style={{ maxWidth: 600, margin: "40px auto", textAlign: "center" }}>
      <Result
        icon={<CloseCircleOutlined style={{ color: "red" }} />}
        status="error"
        title="Payment Failed!"
        subTitle="We were unable to process your payment."
      />

      {/* Optional transaction ID display */}
      {sessionId && (
        <div style={{ marginTop: 15 }}>
          <Title level={5}>Transaction Reference</Title>
          <Text type="secondary">{sessionId}</Text>
        </div>
      )}

      <div style={{ marginTop: 25 }}>
        <Button type="primary" onClick={() => navigate("subscription-plans")}>
          Try Again
        </Button>

        <Button style={{ marginLeft: 10 }} onClick={() => navigate("create-network")}>
          Go Home
        </Button>
      </div>
    </Card>
  );
};

export default PaymentFailed;